<template>
  <div>
    <b-button :disabled="!viewFormLoaded" variant="primary" size="md" v-b-modal.modal-editSafetyForm class=" mr-2" >
      Edit
    </b-button>
    <!-- Safety Form Modal -->
    <b-modal id="modal-editSafetyForm" class="safety-form-modal" scrollable centered ok-title="Submit" @ok="handleSafetyFormModalSubmit" size="lg">
      <div slot="modal-header">
        <h4>{{ formData.displayName ? formData.displayName : '' }}</h4>
        <p>{{ formData.description ? formData.description : '' }}</p>
      </div>
      <div v-for="(input, index) in selectedFormData.fields" :key="index">
        <div style="text-align: end">
          <div class="row mb-3" v-if="
            input.type === 'checkbox' ||
            input.type === 'textarea' ||
            input.type === 'number'
          ">
            <label class="col-3 my-auto">
              <span v-if="input.required && input.type !== 'checkbox'" style="color: #f46a6a">*</span>
              {{ input.label }}
            </label>
            <b-checkbox v-if="input.type === 'checkbox'" :id="input.name.replace(/\s+/g, '')" v-model="input.value"
              :type="input.type" />
            <b-textarea class="col-7" :id="input.name.replace(/\s+/g, '')" v-else-if="input.type === 'textarea'"
              :type="input.type" v-model="input.value" />
            <b-form-input class="col-2" :id="input.name.replace(/\s+/g, '')" v-else-if="input.type === 'number'"
              :type="input.type" v-model="input.value" />
          </div>
          <div class="row mb-3 text-center" v-else-if="input.type === 'label'">
            <h5 class="col-12">{{ input.label }}</h5>
          </div>
          <div class="row mb-4" v-else-if="input.type === 'dropdown'">
            <label class="col-3 my-auto">
              <span v-if="input.required && input.type !== 'checkbox'" style="color: #f46a6a">*</span>
              {{ input.label }}
            </label>
            <b-form-select v-if="input.collectionData !== undefined" class="col-7" :id="input.name.replace(/\s+/g, '')"
              :options="input.collectionData.values" v-model="input.value" full-width></b-form-select>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Safety Form Modal End -->
  </div>
</template>
  
  <script>
  import Vue from 'vue';
  import firebase from 'firebase';
  import VueToast from 'vue-toast-notification';
  import 'vue-toast-notification/dist/theme-sugar.css';
  import { cssEscape } from '../../helper/helpers';
  import lodash from 'lodash';
  
  Vue.use(VueToast);
  
  export default {
    props:{
      formData: Object,
      viewFormLoaded: Boolean
    },
    data() {
      return {
        selectedFormData: {}
      };
    },
    methods: {
      handleSafetyFormModalSubmit: function() {
        let safetyForm = {};
  
        // validate form inputs
        this.selectedFormData.fields.map((input) => {
          // remove spaces from name
          let name = input.name.replace(/\s+/g, '');
          let element = document.querySelector(`#${cssEscape(name)}`);
  
          if (
            (input.value === undefined ||
              input.value === null ||
              (input.type !== 'checkbox' ? input.value.trim() === '' : '')) &&
            input.required &&
            input.type !== 'label' &&
            input.type !== 'checkbox'
          ) {
            // add error class to specific input component
            if (element !== null) {
              element.classList.add('is-invalid');
            }
          } else {
            // remove error class / add the name/value pair to form object / add null if no value exists
            if (input.type !== 'label') {
              if (element !== null) {
                element.classList.remove('is-invalid', 'ddl-is-invalid');
              }
              if (input.value === undefined || input.value === null) {
                if (input.type === 'checkbox') {
                  // if a checkbox is left untouched when submitted then we need to set its value to false instead of null
                  safetyForm[name.toLowerCase()] = false;
                } else {
                  safetyForm[name.toLowerCase()] = null;
                }
              } else {
                safetyForm[name.toLowerCase()] = input.value;
              }
            }
          }
        });

        let revision = {
          date: new Date(this.formData.date),
          employee: JSON.parse(sessionStorage.getItem('authUser')).displayName,
        };

        this.formData.fields.forEach((field)=>{
          revision[field.name.toLowerCase()] = field.value ? field.value : null
        });
  

        safetyForm['dateSubmitted'] = new Date();
        safetyForm['employee'] = this.formData.employee;
        safetyForm['user'] = firebase.auth().currentUser.uid;
        safetyForm['revisions'] = this.selectedFormData.revisions;
        safetyForm.revisions.push(revision);
        // update the submitted safety form in the db
        try {
          firebase
            .firestore()
            .collection('safetyForms')
            .doc(this.selectedFormData.formID)
            .set(safetyForm, {merge: true}) // using set({},{merge:true}) works like update() but doesn't read dot notation so we can update fields with periods in them
            .then(() => {
              // now update the formData in the parent component
              this.selectedFormData.date = new Date();
              this.selectedFormData.revisions = safetyForm.revisions;
              this.$emit('update-safety-form-data', lodash.cloneDeep(this.selectedFormData));

              Vue.$toast.open({
                message: 'Successfully edited safety form',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });    
            })
            .catch((err) => {
              Vue.$toast.open({
                message: `Error editing safety form in database`,
                type: 'error',
                duration: 4000,
                position: 'top-right',
              });
              console.log('Error editing safety form in database: ', err);
            });
        } catch (err) {
          Vue.$toast.open({
            message: `Error editing safety form`,
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
          console.log('Error editing safety form: ', err);
        }
      },
    },
    watch: {
      viewFormLoaded: function(newVal){
        if(newVal === true){
          this.selectedFormData = lodash.cloneDeep(this.formData);
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .safety-form-card {
    border: 1px solid #eff2f7;
    .required-label-symbol {
      color: #f46a6a;
    }
  }
  .safety-form-card:hover {
    cursor: pointer;
    transition: 0.2s ease-in;
    border-color: #556ee6;
    h5,
    p,
    i {
      color: #556ee6;
    }
  }
  </style>
  